import { render, staticRenderFns } from "./MallGoods.vue?vue&type=template&id=11980595&scoped=true"
import script from "./MallGoods.vue?vue&type=script&lang=js"
export * from "./MallGoods.vue?vue&type=script&lang=js"
import style0 from "./MallGoods.vue?vue&type=style&index=0&id=11980595&prod&lang=css"
import style1 from "./MallGoods.vue?vue&type=style&index=1&id=11980595&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11980595",
  null
  
)

export default component.exports